export var MatchingOperator;
(function (MatchingOperator) {
    MatchingOperator["equal"] = "=";
    MatchingOperator["notEqual"] = "!=";
    MatchingOperator["regexMatch"] = "=~";
    MatchingOperator["notRegexMatch"] = "!~";
})(MatchingOperator || (MatchingOperator = {}));
